/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.space.listRepos'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  space: /*#__PURE__*/ l.string(),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 1000 }),
      100,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  repos: /*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<Repo>((() => repo) as any)),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** List the known repos that hold data in a space (the writer set), with each repo's current rev and commit hash. Served by the space host. This is the sync boundary, not an access-control list: it enumerates only writers, never readers. The set is what the authority claims from write notifications and is not itself authoritative; a repo's host is the source of truth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['SpaceNotFound'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type Repo = {
  $type?: 'com.atproto.space.listRepos#repo'

  /**
   * The DID of a repo that holds data in the space.
   */
  did: l.DidString

  /**
   * The repo's current revision (TID), as last reported to the authority. May lag the repo host, which is the source of truth.
   */
  rev: l.TidString

  /**
   * The repo's current commit hash (sha256 of the LtHash state), as last reported to the authority.
   */
  hash: Uint8Array
}

export type { Repo }

const repo = /*#__PURE__*/ l.typedObject<Repo>(
  $nsid,
  'repo',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    rev: /*#__PURE__*/ l.string({ format: 'tid' }),
    hash: /*#__PURE__*/ l.bytes(),
  }),
)

export { repo }
